import { Flex, Typography } from '@banhala/ui-kit';
import { IconBrandIconThirdPL } from '../../../IconBrandIconThirdPL';

export const ThirdPLDeliveryOptionBadge = ({
  isSoldOut,
  orderDeadline,
}: {
  isSoldOut: boolean;
  orderDeadline: string | null;
}) => (
  <Flex.Row alignItems={'center'} gap={4}>
    <IconBrandIconThirdPL width={49} height={13} />
    {isSoldOut ? (
      <Typography type={'body4'} color={'content_disabled'}>
        품절
      </Typography>
    ) : (
      <Typography type={'body4'} color={'content_slate_primary'}>
        {orderDeadline ?? ''}
      </Typography>
    )}
  </Flex.Row>
);
